import React from 'react';
import PokerVisual from '../PokerVisual/PokerVisual';
import './Table.css';
// Import PlaygroundPosition to use the specific type
import { PlaygroundPosition, Street } from '../../pages/PlaygroundPage/PlaygroundPage';

// Update SeatMeta to use PlaygroundPosition for the label
export interface SeatMeta { 
  id: number; 
  label: PlaygroundPosition; // <-- Use PlaygroundPosition
  tag?: string; 
}
export type ActionType = 'fold' | 'call' | 'raise' | 'check' | 'bet' | 'straddle';

export interface TableProps {
  seatCount?: number;
  seats?: SeatMeta[];
  onAction?: (seatId: number, action: ActionType) => void;
  heroSeatId: number | null;
  heroTargetVisualIndex: number;
  isSetupComplete: boolean;
  smallBlind: number;
  bigBlind: number;
  heroCards?: { holeCard1: string; holeCard2: string };
  onHeroCard1Click?: () => void;
  onHeroCard2Click?: () => void;
  // Community cards props
  communityCards?: {
    flopCard1: string;
    flopCard2: string;
    flopCard3: string;
    turnCard: string;
    riverCard: string;
  };
  onFlopCard1Click?: () => void;
  onFlopCard2Click?: () => void;
  onFlopCard3Click?: () => void;
  onFlopCardsClick?: () => void;
  onTurnCardClick?: () => void;
  onRiverCardClick?: () => void;
  stackSizes: Record<number, number>;
  onStackChange: (seatId: number, value: string) => void;
  pot: number;
  currentPlayerId: number | null;
  foldedPlayerIds: Set<number>;
  currentBetToCall: number;
  currentStreet: Street;
  nextPlayerToActId: number | null;
  onSeatClick: (seatId: number) => void;
  isDebugSwivelModeActive?: boolean;
  playerStreetContributions?: Record<number, number>;
}

const Table: React.FC<TableProps> = ({
  seatCount = 9,
  seats = [],
  heroSeatId,
  heroTargetVisualIndex,
  onAction,
  isSetupComplete,
  smallBlind,
  bigBlind,
  heroCards,
  onHeroCard1Click,
  onHeroCard2Click,
  communityCards,
  onFlopCard1Click,
  onFlopCard2Click,
  onFlopCard3Click,
  onFlopCardsClick,
  onTurnCardClick,
  onRiverCardClick,
  stackSizes,
  onStackChange,
  pot,
  currentPlayerId,
  foldedPlayerIds,
  currentBetToCall,
  currentStreet,
  nextPlayerToActId,
  onSeatClick,
  isDebugSwivelModeActive,
  playerStreetContributions,
}) => {
  console.log('[Table.tsx] isDebugSwivelModeActive being passed to PokerVisual:', isDebugSwivelModeActive);

  return (
    <div className="table">
      <PokerVisual
        seatCount={seatCount}
        seats={seats}
        heroSeatId={heroSeatId}
        heroTargetVisualIndex={heroTargetVisualIndex}
        onAction={onAction}
        isSetupComplete={isSetupComplete}
        smallBlind={smallBlind}
        bigBlind={bigBlind}
        heroCards={heroCards}
        onHeroCard1Click={onHeroCard1Click}
        onHeroCard2Click={onHeroCard2Click}
        communityCards={communityCards}
        onFlopCard1Click={onFlopCard1Click}
        onFlopCard2Click={onFlopCard2Click}
        onFlopCard3Click={onFlopCard3Click}
        onFlopCardsClick={onFlopCardsClick}
        onTurnCardClick={onTurnCardClick}
        onRiverCardClick={onRiverCardClick}
        stackSizes={stackSizes}
        onStackChange={onStackChange}
        currentPlayerId={currentPlayerId}
        foldedPlayerIds={foldedPlayerIds}
        currentBetToCall={currentBetToCall}
        currentStreet={currentStreet}
        nextPlayerToActId={nextPlayerToActId}
        onSeatClick={onSeatClick}
        isDebugSwivelModeActive={isDebugSwivelModeActive}
        playerStreetContributions={playerStreetContributions}
        pot={pot}
      />
    </div>
  );
};

export default Table; 